import { get as _get } from 'lodash-es';

const config = {
    ...window.CareLineLive.config,
};

export default config;

export const debug = Boolean(config.debug || false);

export const tempaidEnabled = config.integrations?.tempaid ?? false;

/**
 * @param {string} path
 * @param {*} defaultValue
 *
 * @return {*}
 */
export function get(path, defaultValue = undefined) {
    return _get(config, path, defaultValue);
}
